import { CircleAlert } from 'components/icons';
import { Alert, AlertDescription, AlertTitle } from 'components/ui/alert';
import { useInvoiceFlow } from 'pages/invoices/hooks/useInvoiceFlow';
import { FormattedMessage } from 'react-intl';
import { InvoiceData } from 'types/invoices';

/**
 * Under the header on every tab: the last word of the approval flow that the next step answers, a postpone request
 * or a rejection, with its reason. A postponed invoice's own notice is the General tab's.
 */
export function InvoiceFlowNotice({ invoice }: { invoice: InvoiceData }) {
    const { isRequestedToPostpone, isPostponeDisagreedContinued, isPostponeRejected, isInvoiceRejected } =
        useInvoiceFlow(invoice);
    const lastTransition = invoice.invoiceTransitions?.[0];
    const messageId = isRequestedToPostpone
        ? 'invoices.alerts.requests-postpone-name'
        : isPostponeDisagreedContinued
          ? 'invoices.alerts.disagreed-continue-postpone-name'
          : isPostponeRejected
            ? 'invoices.alerts.rejected-postpone-name'
            : isInvoiceRejected
              ? 'invoices.alerts.rejected-invoice-name'
              : undefined;
    if (!messageId || !lastTransition) return null;
    return (
        <Alert className="border-warning bg-warning-tint text-warning-ink mt-4">
            <CircleAlert aria-hidden />
            <AlertTitle>
                <FormattedMessage id={messageId} values={{ name: lastTransition.changedByEmployee?.name || '-' }} />
            </AlertTitle>
            {lastTransition.comment || lastTransition.matter ? (
                <AlertDescription className="text-current opacity-90">
                    {lastTransition.comment ? (
                        <div>
                            <FormattedMessage id="invoices.alerts.reason" values={{ reason: lastTransition.comment }} />
                        </div>
                    ) : null}
                    {lastTransition.matter ? (
                        <div>
                            <FormattedMessage id="invoices.alerts.case" values={{ case: lastTransition.matter.name }} />
                        </div>
                    ) : null}
                </AlertDescription>
            ) : null}
        </Alert>
    );
}
